import { tv } from '~/utils/tv'

export const helperTextRoot = tv({
  base: 'mt-halfpulse flex w-full px-onepulse font-semibold',
  variants: {
    error: {
      true: '',
      false: 'text-neutral-default',
    },
  },
  defaultVariants: {
    error: false,
  },
})

export const helperTextVariants = tv({
  base: 'flex flex-row items-center justify-start gap-half-pulse text-ellipsis font-family-modern font-semibold text-threepulse',
  variants: {
    error: {
      true: ' text-text-danger-alternative',
      false: 'text-text-neutral-alternative',
    },
    disabled: {
      true: 'cursor-not-allowed text-text-neutral-disabled',
      false: '',
    },
    readonly: {
      true: 'cursor-not-allowed text-text-neutral-readonly',
      false: '',
    },
  },
})

export const helperTextLabelVariants = tv({
  base: 'line-clamp-2 overflow-hidden text-ellipsis pl-onepulse text-left',
})

export const helperTextLabelErrorVariants = tv({
  base: 'line-clamp-2 overflow-hidden text-ellipsis pl-onepulse text-left',
})
